<tds-table vertical-dividers="false" compact-design="false" responsive="false">
  <tds-table-toolbar table-title="List of all trucks">
    <div slot="end" class="tds-u-flex tds-u-align-items-center tds-u-h-100 tds-u-gap1">
      <tds-button type="ghost" size="sm" text="Add Truck" (click)="createTruck()" />
    </div>
  </tds-table-toolbar>
  <tds-table-header>
    <tds-header-cell cell-key="id" cell-value="ID" disable-padding="false" text-align="left" />
    <tds-header-cell cell-key="name" cell-value="Name" disable-padding="false" text-align="left" />
    <tds-header-cell cell-key="fuelType" cell-value="Fuel type" disable-padding="false" text-align="left" />
    <tds-header-cell cell-key="numberOfAxis" cell-value="Number of Axis" disable-padding="false" text-align="left" />
    <tds-header-cell cell-key="actions" cell-value="" disable-padding="false" text-align="left" />
  </tds-table-header>
  <tds-table-body>
    <tds-table-body-row *ngFor="let truck of trucks">
      <tds-body-cell cell-key="id" disable-padding="false" text-align="left">{{ truck.Id }}</tds-body-cell>
      <tds-body-cell cell-key="driver" disable-padding="false" text-align="left">{{ truck.Name }}</tds-body-cell>
      <tds-body-cell cell-key="country" disable-padding="false" text-align="left">{{ truck.FuelType }}</tds-body-cell>
      <tds-body-cell cell-key="mileage" disable-padding="false" text-align="left">{{
        truck.NumberOfAxis
      }}</tds-body-cell>
      <tds-body-cell cell-key="actions" disable-padding="false" text-align="left">
        <tds-button type="button" variant="ghost" size="sm" (click)="editTruck(truck.Id)">
          <tds-icon slot="icon" size="20px" name="edit" />
        </tds-button>
        <tds-button
          type="button"
          variant="ghost"
          size="sm"
          (click)="modalService.openConfirmation(truck.Id, deleteTruck.bind(this))"
        >
          <tds-icon slot="icon" size="20px" name="trash" />
        </tds-button>
      </tds-body-cell>
    </tds-table-body-row>
  </tds-table-body>
</tds-table>

<app-confirmation-modal
  size="xs"
  modalId="deletion-modal"
  title="Delete Truck"
  message="Are you sure you want to delete this truck ?"
/>
